import React, { useState, useEffect, useRef, useMemo } from "react";
import styled from "styled-components";
import gileadChat from "img/genai/gileadiconchatA.svg";
import { useKeycloak } from "@react-keycloak/web";
import { EdetailCard } from "./EdetailCard";
import { LoadingCircle, TimedLoadingCircle } from "../utils/LoadingCircle";
import { LoaderEdt } from "../utils/LoaderEdt";
import { SlideCard } from "./SlideCard";
import { RetrivedSlide } from "./RetrivedSlide";
import { fetchModules, fetchPreview } from "../api/genapi";
import {
  useAutoScroll,
  formatTopicText,
  formatBotMessage,
} from "./utils/AutoScroll";
import { SelectedRecSlide } from "./sliderec/SelectedRecSlide";

export const ChatContainer = ({
  messages,
  checkeDetailSelect,
  SetedetailTextShow,
  checkSlideSelect,
  productCountry,
  selectedeDetail,
  slidesData,
  modulesData,
  selectedSlide,
  setedtName,
  countryName,
  setSelectedEdetail,
  edetailtextShow,
  textShow,
  slidetextShow,
  setSlideBubbleState,
  moduleCreation,
  multiModules,
  slidePopup,
  generatemultimodBtn,
  setTextShow,
  moduleGenerate,
  cancelbtn,
  cancelAbort,
  triggerMulti,
  restartMod,
  startAssembly,
  startNew,
  multiIP,
}) => {
  const [edetailData, setEdetailData] = useState(null);
  const [slideData, setSlideData] = useState(null);
  const [fullSlideData, setfullSlideData] = useState(null);
  const [loadingStates, setLoadingStates] = useState({});
  const { keycloak } = useKeycloak();
  const chatContentRef = useRef(null);
  const [greySlideIds, setGreySlideIds] = useState([]);
  const [gryRetrivedSlideIds, setGryRetrivedSlideIds] = useState(false);
  const allSlideIdsRef = useRef([]); // Us
  const { showNewBubble, setShowNewBubble } = startNew;
  const { setShowSlideMsg } = slidePopup;
  const { isMultiline, setIsMultiline } = multiIP;
  const greyOld = { gryRetrivedSlideIds, setGryRetrivedSlideIds };
  const BotText = React.memo(function BotText({ text }) {
    const formattedText = useMemo(() => {
      return formatBotMessage(text);
    }, [text]);

    return <>{formattedText}</>;
  });

  // Helper functions remain the same
  const getFirstLetters = () => {
    const userName = !!keycloak.authenticated
      ? keycloak.tokenParsed.name
      : null;
    if (!userName) return "";
    const nameArray = userName.split(" ");
    const firstLetters = nameArray.map((name) => name.charAt(0));
    return firstLetters.slice(0, 2).join("").toUpperCase();
  };

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const time = date
      .toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .toUpperCase();
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return `${time}, ${day} ${month}`;
  };

  const getTime = (message) => {
    // For fullslide — just a static delay
    if (message.responseType === "fullslide" || message.text?.fullslide) {
      return 9000;
    }

    if (message.responseType === "edetail" || message.text?.edetail) {
      return 0;
    }

    if (message.responseType === "slide" || message.text?.slidedetail) {
      return 7000;
    }

    // For any other generic message
    return 500;
  };

  useEffect(() => {
    const processMessages = async () => {
      messages.forEach((message) => {
        if (message.isLoading) return;
        if (!loadingStates[message.id]) {
          const isEdetailResponse = message.responseType === "edetail";
          const isSlideResponse = message.responseType === "slide";
          const isFullslideResp =
            message.responseType === "fullslide" || !!message.text?.fullslide;

          // Set initial loading state
          setLoadingStates((prev) => ({
            ...prev,
            [message.id]: {
              isLoading: true,
              isEdetail: isEdetailResponse,
              isSlide: isSlideResponse,
              isFullSlide: isFullslideResp,
              showContent: false,
              duration: null, // initially null
            },
          }));

          // Start processing
          (async () => {
            const duration = await getTime(message);

            // set duration immediately
            setLoadingStates((prev) => ({
              ...prev,
              [message.id]: {
                ...prev[message.id],
                duration: duration,
              },
            }));

            const timer = setTimeout(() => {
              setLoadingStates((prev) => ({
                ...prev,
                [message.id]: {
                  ...prev[message.id],
                  isLoading: false,
                  showContent: true,
                },
              }));

              // Set response data
              if (isEdetailResponse) {
                setEdetailData(message.data || message.text?.edetail);
              } else if (isSlideResponse) {
                setSlideData(message.data);
              } else if (isFullslideResp) {
                setfullSlideData(message.data);
              }
            }, duration);

            return () => clearTimeout(timer);
          })();
        }
      });
    };

    processMessages();
  }, [messages]);

  useAutoScroll(chatContentRef, [messages, textShow, loadingStates, slideData]);

  const edetailMessages = messages.filter(
    (msg) => msg.responseType === "edetail",
  );
  const latestMessageId = edetailMessages[edetailMessages.length - 1]?.id;

  useEffect(() => {
    const slides = messages.filter(
      (msg) => msg.responseType === "slide" && msg.sender === "bot",
    );
    const ids = slides.map((msg) => msg.id);
    allSlideIdsRef.current = ids; // Update ref
  }, [messages]);

  // 2. Now this will ALWAYS get current IDs
  const handleGreyOutClick = () => {
    setGreySlideIds([...allSlideIdsRef.current]); // Force new array
  };

  //
  const hasSelection = useMemo(() => {
    return (
      (edetailtextShow && selectedeDetail !== null) ||
      textShow ||
      (slidetextShow && selectedSlide !== null)
    );
  }, [
    selectedeDetail,
    edetailtextShow,
    textShow,
    slidetextShow,
    selectedSlide,
  ]);
  const shouldHideInputBox = selectedeDetail || selectedSlide;

  useEffect(() => {
    // Direct check
    const isFullslide = messages.some(
      (msg) => msg.responseType === "fullslide",
    );

    setShowSlideMsg(isFullslide);
  }, [messages, setShowSlideMsg]);

  return (
    <Container
      $hasSelection={hasSelection}
      $shouldHideInputBox={shouldHideInputBox}
      $multiline={isMultiline}
    >
      <ChatContent ref={chatContentRef}>
        {messages.map((message) => {
          if (message.isLoading) {
            return (
              <BotMessageContainer key={message.id}>
                <MainBoxBot>
                  <div>
                    <MessageIcon src={gileadChat} alt="Bot" />
                  </div>
                  <LoaderEdt />
                </MainBoxBot>
              </BotMessageContainer>
            );
          }
          const loadingState = loadingStates[message.id] || {
            isLoading: false,
            showContent: true,
          };
          // const loadingStateForMessage = loadingStates[message.id] || {};

          if (message.sender === "user") {
            return (
              <UserMessageContainer key={message.id}>
                <MainBoxUser>
                  <UserMessageBubble>
                    <UserText>
                      <TimeStamp>{formatDateTime(message.timestamp)}</TimeStamp>
                      <ChatTextUser>
                        {formatTopicText(message.text)}
                      </ChatTextUser>
                    </UserText>
                  </UserMessageBubble>
                  <UserIcon>{getFirstLetters()}</UserIcon>
                </MainBoxUser>
              </UserMessageContainer>
            );
          }

          return (
            <BotMessageContainer key={message.id}>
              <MainBoxBot>
                <div>
                  <MessageIcon src={gileadChat} alt="Bot" />
                </div>

                {/* Loading states */}
                {loadingState.isLoading && (
                  <>
                    {loadingState.isEdetail ? (
                      <></>
                    ) : loadingState.isSlide ? (
                      <LoadingCircle
                        loaderText={[
                          "Analysing the content across the slides",
                          "Preparing slide view for Selection",
                        ]}
                      />
                    ) : loadingState.isFullSlide ? (
                      <LoaderEdt />
                    ) : (
                      <LoaderEdt />
                    )}
                  </>
                )}
                {/* Content after loading */}
                {!loadingState.isLoading && loadingState.showContent && (
                  <>
                    {/* Regular text */}
                    {typeof message.text === "string" &&
                      !loadingState.isEdetail &&
                      !loadingState.isSlide &&
                      !loadingState.isFullSlide && (
                        <BotMessageBubble>
                          <TimeStamp>
                            {formatDateTime(message.timestamp)}
                          </TimeStamp>
                          <ChatText>
                            <BotText text={message.text} />
                          </ChatText>
                        </BotMessageBubble>
                      )}

                    {/* eDetail content */}
                    {loadingState.isEdetail && edetailData && (
                      <EdetailCard
                        chatContentRef={chatContentRef}
                        message={message}
                        edetail={edetailData}
                        checkeDetailSelect={checkeDetailSelect}
                        productCountry={productCountry}
                        messageId={message.id}
                        formatDateTime={formatDateTime}
                        setedtName={setedtName}
                        SetedetailTextShow={SetedetailTextShow}
                        messages={messages}
                        latestMessageId={latestMessageId}
                        selectedeDetail={selectedeDetail}
                        handleGreyOutClick={handleGreyOutClick}
                        setShowNewBubble={setShowNewBubble}
                        setTextShow={setTextShow}
                        setGryRetrivedSlideIds={setGryRetrivedSlideIds}
                      />
                      // </BotMessageBubble>
                    )}

                    {/* Slide content */}
                    {loadingState.isSlide && slideData && (
                      <BotMessageSlide>
                        <TimeStamp>
                          {formatDateTime(message.timestamp)}
                        </TimeStamp>
                        <SlideCard
                          slideData={message.data}
                          checkSlideSelect={checkSlideSelect}
                          edtName={message.edtName}
                          messages={messages}
                          messageId={message.id}
                          selectedeDetail={selectedeDetail}
                          message={message}
                          setSelectedEdetail={setSelectedEdetail}
                          greySlideIds={greySlideIds}
                          setSlideBubbleState={setSlideBubbleState}
                          moduleCreation={moduleCreation}
                          slidePopup={slidePopup}
                          setGryRetrivedSlideIds={setGryRetrivedSlideIds}
                        />
                      </BotMessageSlide>
                    )}

                    {/* Slide content */}
                    {message.responseType == "slideRes" && (
                      <BotMessageSlide>
                        <TimeStamp>
                          {formatDateTime(message.timestamp)}
                        </TimeStamp>
                        {/* <SelectedRecSlide/> */}
                        <SelectedRecSlide
                          messages={messages}
                          key={message.id}
                          messageId={message.id}
                          data={message.data}
                        />
                      </BotMessageSlide>
                    )}

                    {/* Fullslide content */}
                    {loadingState.isFullSlide && fullSlideData && (
                      <FullContentSlide>
                        <TimeStamp>
                          {formatDateTime(message.timestamp)}
                        </TimeStamp>
                        <RetrivedSlide
                          modulesData={message.data}
                          slideCount={message.slideCount}
                          messageId={message.id}
                          selectedSlide={message.selectedSlide}
                          // selectedSlide={message.slideThumb}
                          messages={messages}
                          countryNameUI={countryName}
                          // currentMessage={message}
                          edtName={message.edtName}
                          userCollectedMeta={message.userCollectedMeta}
                          multiModules={multiModules}
                          generatemultimodBtn={generatemultimodBtn}
                          setTextShow={setTextShow}
                          moduleGenerate={moduleGenerate}
                          cancelbtn={cancelbtn}
                          cancelAbort={cancelAbort}
                          triggerMulti={triggerMulti}
                          restartMod={restartMod}
                          startAssembly={startAssembly}
                          startNew={startNew}
                          greyOld={greyOld}
                        />
                      </FullContentSlide>
                    )}
                  </>
                )}
              </MainBoxBot>
            </BotMessageContainer>
          );
        })}
      </ChatContent>
    </Container>
  );
};

// Base styles (unchanged from your original)
const Container = styled.section`
  overflow-y: auto;
  background: #f5f5f7;
  /* Update height calculation to include shouldHideInputBox */

  height: ${({ $hasSelection, $shouldHideInputBox, $multiline }) => {
    // If input box is hidden, always use the smaller height
    if ($shouldHideInputBox) return `calc(100vh - 169px)`;

    // If multiline is true, use the taller height
    if ($multiline) return `calc(100vh - 264px)`;

    // Otherwise use original logic
    return $hasSelection ? `calc(100vh - 203px)` : `calc(100vh - 169px)`;
  }};
  flex: 1;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  /* Hide scrollbar for Chrome, Safari, and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
`;

const ChatContent = styled.article`
  background: #f5f5f7;
  height: 100%;
  overflow-y: auto;
  padding: 30px 60px;
`;
const ChatText = styled.span`
  font-size: 14px;
  text-align: left;
  white-space: pre-line;
  width: 30rem;
`;
const ChatTextUser = styled.span`
  font-size: 14px;
  text-align: right;
`;
const MainBoxUser = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: start;
  margin-right: 10px;
`;
const MainBoxBot = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: start;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
`;

const TimeStamp = styled.small`
  color: #0a0a0b;
  font-size: 9px;
  margin-top: 4px;
`;

const UserMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 8px 0;
  /* Enhanced responsive design */
  @media screen and (min-width: 1600px) and (max-width: 1800px) {
    margin: 12px 0;
  }

  /* Additional breakpoints for better responsiveness */
  @media screen and (min-width: 1801px) {
    margin: 16px 0;
  }
`;

const UserMessageBubble = styled.div`
  background: #ffffff;
  color: #0a0a0b;
  font-size: 14px;
  padding: 20px 16px;
  border-radius: 12px;
  max-width: 90%;
  word-wrap: break-word;
  min-width: 570px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
`;
const UserText = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
  min-width: 80px;
`;

const BotMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px 0;
`;

const BotMessageBubble = styled.div`
  background: transparent;
  // padding: 10px 15px;
  border-radius: 12px;
  max-width: 80%;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const BotMessageSlide = styled.div`
  background: #ffffff;
  border-radius: 12px;
  max-width: 80%;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 77rem;
  padding: 20px;
`;

const MessageIcon = styled.img`
  border-radius: 50%;
  margin-right: 6px;
`;

const UserIcon = styled.div`
  font-size: 8px;
  color: #fff;
  background-color: #203662;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-weight: 600;
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FullContentSlide = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
`;
